import { connect } from "react-redux";
import get from "lodash/get";

import {
  getRegistration as onGetRegistration,
  registration as onRegistration,
  handleChangeStoreRegistration as onHandleChangeStore,
} from "./../../actions/registrationActions";

const mapStateToProps = (state) => ({
  registration: {
    dataState: state.registration.dataState,
    registrationUserDataState: state.registration.registrationUserDataState,
    registrationUser: get(state, ["registration", "registrationUser"], null),
    registrationItems: get(state, ["registration", "registrationItems"], {}),
    errorsModel: get(state, ['auth', 'errors', 'data', 'model'], null),
    errors: get(state, ["registration", "errors", "data"], null),
  },
});

const mapDispatchToProps = { onGetRegistration, onHandleChangeStore, onRegistration };

const withRegistration = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withRegistration };
